import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './ItineraryCoverHeader.css';
import React from 'react';
import { get, getDictionaryItem, canUseDOM, getPageThemeColors, getColorByTheme } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CuratorPicks from '../atoms/CuratorPicks/CuratorPicks';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import { Text, RichText, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import Video from '../atoms/Video';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import DarkThemeControl from '../BrightcoveVideosAtoms/DarkThemeControl';
var videoWhiteOverlayTime = 750;
var videoFadeTime = 400;
export var ItineraryCoverHeader = function ItineraryCoverHeader(_ref) {
  var fields = _ref.fields,
    rendering = _ref.rendering,
    children = _ref.children,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var days = get(fields, 'data.item.days') || [];
  var moduleId = get(fields, 'data.item.id');
  var rawCurators = get(fields, 'data.item.curators.jss.value');
  var curators = rawCurators ? JSON.parse(rawCurators) : '';
  var dictionary = get(fields, 'data.dictionary');
  var CuratorsPick = getDictionaryItem(dictionary, 'CuratorsPick');
  var darkModeTitle = getDictionaryItem(dictionary, "dark mode") || '';
  //const pois = get(fields, 'data.item.pois.values') || [];
  var title = get(fields, 'data.item.title.jss');
  var introText = get(fields, 'data.item.introText.jss');
  var name = get(fields, 'data.item.name');
  var placeNumber = 0;
  var _fields$data = fields.data,
    addToFavAnalytics = _fields$data.addToFavAnalytics,
    smallBannerClickAnalytics = _fields$data.smallBannerClickAnalytics;
  days.map(function (item) {
    var length = get(item, 'pois.values.length');
    placeNumber += length;
  });
  placeNumber = placeNumber || get(fields, 'data.item.pois.values.length');
  var countDays = days.length;
  var hasCategory = Boolean(get(fields, 'data.item.category.targetItem.title.jss.value'));
  var category = get(fields, 'data.item.category.targetItem.title.jss');
  var hasIntroText = Boolean(introText);
  var hasTitle = Boolean(title);
  var BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  var dictionaryValues = get(fields, 'data.dictionary.dictionaryValues');
  var dayPhrase = dictionaryValues ? get(dictionaryValues[2], 'phrase.jss.value') : '';
  var placesPhrase = dictionaryValues ? get(dictionaryValues[3], 'phrase.jss') : '';
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  var darkMode = get(sitecoreContext, 'darkMode');
  var actions = get(sitecoreContext, 'actions', {});
  var _actions$changeThemeF = actions.changeThemeFunction,
    changeThemeFunction = _actions$changeThemeF === void 0 ? function () {} : _actions$changeThemeF;
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var ColorHex = get(params, 'ColorHex');
  var primaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var primaryColorActive = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  var variables = BackgroundColorHex ? {
    '--m57-itinerary-cover-header-primary-color': BackgroundColorHex,
    '--m57-itinerary-cover-header-active-primary-color': ActiveColorHex,
    '--m57-itinerary-cover-header-color': ColorHex
  } : {
    '--m57-itinerary-cover-header-primary-color': primaryColor,
    '--m57-itinerary-cover-header-active-primary-color': primaryColorActive,
    '--m57-itinerary-cover-header-color': getColorByTheme(primaryPageThemeColor)
  };
  var renderMediaPlaceholder = function renderMediaPlaceholder() {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "media-header-general",
      rendering: rendering,
      mediaDesc: introText.value
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, params && params['Dark Mode Switcher Show'] && /*#__PURE__*/React.createElement(DarkThemeControl, {
    handleClick: changeThemeFunction,
    label: darkModeTitle,
    value: darkMode,
    params: params
  }), /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group remove-padding-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    "data-animation-breakpoint": "768",
    className: "header-animation-breakpoint header__poi header__full-width-mob js-header-bm-parent"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-bb__wrapper header-bb__wrapper--poster-show"
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder(), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: 'my-icon-white header__fav-btn',
    componentPrimaryColor: BackgroundColorHex,
    componentPrimaryColorActive: ActiveColorHex,
    analyticsClick: function analyticsClick(action) {
      return tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), "".concat(action, " : ").concat(name));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "header-bb__info js-header-bm header-animation__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-animate__content-bg"
  }), /*#__PURE__*/React.createElement(CuratorPicks, {
    copy: CuratorsPick,
    curators: curators.curators,
    analytics: {
      smallBannerClickAnalytics: smallBannerClickAnalytics,
      params: params,
      name: name
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "header__type-tag"
  }, hasCategory && /*#__PURE__*/React.createElement(Text, {
    field: category
  })), hasTitle ? /*#__PURE__*/React.createElement("h1", {
    className: "header__info-title"
  }, /*#__PURE__*/React.createElement(Text, {
    field: title
  })) : '', /*#__PURE__*/React.createElement("div", {
    className: "header__icons"
  }, placeNumber > 0 && /*#__PURE__*/React.createElement("div", {
    className: "details-icon__image"
  }, /*#__PURE__*/React.createElement("p", {
    className: "details-text"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "details-icon__img",
    width: "17",
    height: "21",
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.639 1.01349C6.68405 1.00075 4.79939 1.74184 3.37673 3.08275C1.95407 4.42365 1.10285 6.2612 1 8.21348V8.25148C1.125 12.6175 4.95 16.6445 8.335 20.0065C8.47871 20.1441 8.67098 20.2193 8.86991 20.2157C9.06884 20.2122 9.25829 20.1301 9.397 19.9875C12.529 16.6155 16.672 12.9615 16.592 8.04448C16.4577 6.06167 15.5475 4.21163 14.0587 2.8952C12.5699 1.57877 10.6223 0.901987 8.638 1.01149L8.639 1.01349ZM8.665 2.31349C10.2919 2.21663 11.8907 2.76894 13.111 3.8493C14.3312 4.92966 15.0731 6.44985 15.174 8.07647C15.239 12.0495 11.909 15.3025 8.856 18.5415C5.68799 15.3415 2.53599 11.6995 2.42599 8.24148C2.4904 6.63626 3.17757 5.11925 4.34175 4.01219C5.50593 2.90513 7.05556 2.2951 8.66199 2.31147L8.665 2.31349Z",
    fill: "#57585C",
    stroke: "#57585C",
    "stroke-width": "0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99609 10.5156C10.1007 10.5156 10.9961 9.62019 10.9961 8.51562C10.9961 7.41106 10.1007 6.51562 8.99609 6.51562C7.89152 6.51562 6.99609 7.41106 6.99609 8.51562C6.99609 9.62019 7.89152 10.5156 8.99609 10.5156Z",
    fill: "#57585C"
  })), placeNumber, " ", /*#__PURE__*/React.createElement(Text, {
    field: placesPhrase
  }))), countDays > 0 && /*#__PURE__*/React.createElement("div", {
    className: "details-icon__image"
  }, /*#__PURE__*/React.createElement("p", {
    className: "details-text"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "details-icon__img",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4V10H14.5M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
    stroke: "#57585C",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })), /*#__PURE__*/React.createElement("span", null, dayPhrase && countDays > 0 && dayPhrase.replace('{day}', countDays))))), /*#__PURE__*/React.createElement("div", {
    className: "header__content-p"
  }, hasIntroText && /*#__PURE__*/React.createElement(RichText, {
    field: introText
  })), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: 'my-icon-white header__fav-btn',
    componentPrimaryColor: BackgroundColorHex,
    componentPrimaryColorActive: ActiveColorHex,
    analyticsClick: function analyticsClick(action) {
      return tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), "".concat(action, " : ").concat(name));
    }
  })))))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "header-animation ".concat(commonStyles, " ").concat(fullWidthStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(headerImageStyle)
  }, children);
};
var commonStyles = "ceqehn";
var ltrStyles = "l1trs4xa";
var rtlStyles = "r1ohf2g6";
export default ItineraryCoverHeader;